import React, { Component } from 'react';
import './App.css';
import {CLIENT_ID, GoalsService, LoginService, SKService} from '../api/server_calls';
import Dropdown from "../dropdown";
import TitleBanner from "../title-banner";
import Scale from "../scale";
import Message from "../message";
import Table from "../table";
import Slider from "../slider";
import SubjectLine from "../subject-line";
import Highcharts from "highcharts";
import GBStdChart from "../pages/GB/GBStdChart";
import Legend from "../legend";
import Label from "../label";
import Closer from "../closer";
import Tooltip from "../tooltip";

class App extends Component {

    constructor(props) {
        super(props);

        var that = this;
        this.state = {
            colorStockout:"#002060",
            colorLARC:"#1d4e92",
            colorCHW: "#3892c6",
            colorOutreach: "lightgreen",//"#befad8",
            colorPharma: "#0b9444",
            colorPPFP: "#954f72",
            colorYouth: "#ec465e",
            colorSBC: "#f49100",
            colorMedia: "#fcd116",
            factor: 0,
            title1: "Policy Environment",
            title2: "Stockout Reductions",
            title3: "Expand Access to Methods",
            title4: "CHW/CBD Provision of FP",
            title5: "Mobile Outreach",
            title6: "Pharmacies / Drug Shops",
            title7: "Postpartum FP",
            title8: "Youth Interventions",
            title9: "SBC: Community",
            title10: "SBC: Mass Media",
            sideBarVisible: true,
            pageID: 'Home',
            loggedIn: false,
            projectCreated : false,
            clientID : null,
            breakoutBase1:26.7,
            breakoutBase2:15.1,
            breakoutEnd1:64,
            breakoutEnd2:36,
            sliderValue1 : "32",
            sliderValue2 : "17",
            sliderValue3 : "21",
            sliderValue4 : "0",
            sliderValue5 : "0",
            sliderValue6 : "5",
            sliderValue7 : "0",
            sliderValue8 : "0",
            sliderValue9 : "15",
            sliderValue10 : "39",
            sliderBaseline1: "32",
            sliderBaseline2: "17",
            sliderBaseline3: "21",
            sliderBaseline4: "0",
            sliderBaseline5: "0",
            sliderBaseline6: "5",
            sliderBaseline7: "0",
            sliderBaseline8: "0",
            sliderBaseline9: "15",
            sliderBaseline10: "39",
            visPolicy: "none",
            visPPFP: "none",
            visLARC: "none",
            visCHW: "none",
            visOutreach: "none",
            visPharma: "none",
            visStockout: "none",
            visYouth: "none",
            visSBC: "none",
            visMedia: "none",
            tableStart1: "182,000",
            tableStart2: "20",
            tableStart3: "10",
            tableStart4: "270",
            tableStart5: "0",
            tableStart6: "0",
            tableStart7: "0",
            tableStart8: "1,225,000",
            tableStart9: "3,219,000",
            tableValue1 : "181,000",
            tableValue2 : "20",
            tableValue3 : "10",
            tableValue4 : "320",
            tableValue5 : "0",
            tableValue6 : "0",
            tableValue7 : "0",
            tableValue8 : "1,456,000",
            tableValue9 : "3,825,000",
            scaleValue1 : 0,
            scaleValue2 : 0,
            scaleValue3 : 0,
            scaleValue4 : 0,
            scaleValue5 : 0,
            scaleValue6 : 0,
            scaleValue7 : 0,
            scaleValue8 : 0,
            scaleValue9 : 0,
            checkDisplay1: "hidden",
            checkDisplay2: "hidden",
            checkDisplay3: "hidden",
            checkDisplay4: "hidden",
            checkDisplay5: "hidden",
            checkDisplay6: "hidden",
            checkDisplay7: "hidden",
            checkDisplay8: "hidden",
            checkDisplay9: "hidden",
            checkDisplay10: "hidden",
            upArrow1:"hidden",
            upArrow2:"hidden",
            upArrow3:"hidden",
            upArrow4:"hidden",
            upArrow5:"hidden",
            upArrow6:"hidden",
            upArrow7:"hidden",
            upArrow8:"hidden",
            upArrow9:"hidden",
            upArrow10:"hidden",
            downArrow1:"hidden",
            downArrow2:"hidden",
            downArrow3:"hidden",
            downArrow4:"hidden",
            downArrow5:"hidden",
            downArrow6:"hidden",
            downArrow7:"hidden",
            downArrow8:"hidden",
            downArrow9:"hidden",
            downArrow10:"hidden",
            badgeColor:"red",
            barValue : 0,
            graphValue: 35,
            noData: 61,
            notSexuallyActive:0,
            UMSAUser:0,
            UMSANonUser:0,
            marriedUser:5,
            marriedNonUser:34,
            obj:{
                yAxisLabel: "mCPR (all women)",
                title: "",
                subsetLabels: [
                    "Average",
                    "Highest",
                    "Projected"
                ],
                subsetColors: [
                    "grey",
                    "orange",
                    "green"
                ],
                subsetsToLegend: "",
                chartData: [
                    [
                        [2017, 15],
                        [2022, 19]
                    ],
                    [
                        [2017, 15],
                        [2022, 35]
                    ],
                    [
                        [2017, 15],
                        [2022, 14]
                    ]
                ]
            },
            stock: {
                title: "Stock outs by method",
                subsetLabels: [
                    "Stockout",
                    "Stockout",
                    "Stockout",
                    "Stockout",
                    "Stockout"
                ],
                subsetColors: [
                    "blue",
                    "blue",
                    "blue",
                    "blue",
                    "blue"
                ],
                subsetsToLegend: "",
                chartData: [[
                    [0],
                    [0],
                    [0],
                    [0],
                    [0]
                ]],
                pointLabels: [
                    "Condom (m)",
                    "Pills",
                    "Injectables",
                    "IUD",
                    "Implant"
                ],
            }
        };
        this.state.bar = {
            title: "",
            yAxisLabel:"% pt increase in mCPR (2017 to 2022)",
            subsetLabels: [
                "Percentage",
                // this.state.title1,
                this.state.title2,
                this.state.title3,
                this.state.title4,
                this.state.title5,
                this.state.title6,
                this.state.title7,
                this.state.title8,
                this.state.title9,
                this.state.title10
            ],
            subsetColors: [
                "rgba(150, 150, 150, 0.25)",
                this.state.colorStockout,
                this.state.colorLARC,
                this.state.colorCHW,
                this.state.colorOutreach,
                this.state.colorPharma,
                this.state.colorPPFP,
                this.state.colorYouth,
                this.state.colorSBC,
                this.state.colorMedia
            ],
            pointLabels: [
                "Increase in mCPR",
                "Growth limited by low demand"
            ],
            subsetsToLegend: "",
            stacking: true,
            chartData: [
                [
                    [0],
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ],
                [
                    [0]
                ]
            ]
        };
        this.state.yw = {
            title: "Distribution of youth by marital status, sexual activity, and contraceptive use",
            yAxisLabel: "% of Youth (15 - 24)",
            chartType: 12,
            showLegend:true,
            subsetLabels: [
                "Unmarried, No Data On Sexual Activity",
                "Unmarried Not Sexually Active",
                "Unmarried Sexually Active",
                "Married Youth"
            ],
            subsetColors: [
                "lightgrey",
                "darkgrey",
                "lightblue",
                "darkblue"
            ],
            subsetsToLegend: "",
            chartData: [[
                [0],
                [0],
                [this.state.noData]
            ],
                [
                    [0],
                    [0],
                    [this.state.notSexuallyActive]
                ],
                [
                    [this.state.UMSAUser],
                    [this.state.UMSANonUser],
                    [0]
                ],
                [
                    [this.state.marriedUser],
                    [this.state.marriedNonUser],
                    [0]
                ]],
            stacking:true,
            pointLabels: [
                "Users",
                "Non Users *",
                "Not Sexually Active"
            ],
        }

    }

    ToggleSideBar = () => {
        this.setState({
            sideBarVisible: !this.state.sideBarVisible
        });
        //window.dispatchEvent(new Event('resize'));
    };

    ChangePage = (pageID) => {
        this.setState({
            pageID: pageID
        });
    };

    onHandleLogin = () => {
        LoginService.login('Moo', 'cow', () => {
            this.setState({
                loggedIn: true,
                clientID: CLIENT_ID
            });

            localStorage.setItem('CLIENT_ID', CLIENT_ID);
        });
    };

    onHandleLogout = () => {
        LoginService.logout(() => {
            this.setState({
                loggedIn: false
            });
        });
    };

    onCreateProjection = (fileTitle) => {
        SKService.createProject(fileTitle, (result) => {
            if (result.status !== 1) {
                this.setState({
                    projectCreated: true
                });
            }
        });
    };

    onDestroyProjection = () => {
        SKService.destroyProject((result) => {
            if (result.status !== 1) {
                this.setState({
                    projectCreated: false
                });
            }
        });
    };

    componentDidMount () {
        this.setState({
            clientID: localStorage.getItem("CLIENT_ID"),
            loggedIn: (localStorage.getItem("CLIENT_ID") !== null)
        });
        //document.querySelector(".App>article:first-of-type").style.height = (window.innerHeight - 64 - 25 - 15) + "px";
        //GoalsService.pickCountry(parseInt(document.querySelector("select").value), (result) => this.handleDropdown(result));
    }

    handleAbout = () => {
        document.querySelector("#about").style.display = "block";
        document.querySelector("#screen").style.display = "block";
        document.querySelectorAll(".App *").forEach(function(elem) {
            elem.style.opacity = "0.75";
        });
        document.querySelector("#about").style.opacity = "1";
        document.querySelectorAll("#about *").forEach(function(elem) {
            elem.style.opacity = "1";
        });
        document.querySelector(".App").style.position = "fixed";
        document.querySelector("#about").style.height = Math.min(700, window.innerHeight - 64 - 25 - 15) + "px";
        if (navigator.userAgent.toLowerCase().indexOf("edge") > -1) {
            var margin = (window.innerWidth - 500) / 2;
            document.querySelector("#about").style.position = "absolute";
            document.querySelector("#about").style.margin = "0 " + margin + "px";
        }
    }

    handleX = () => {
        document.querySelector("#about").style.display = "none";
        document.querySelector("#screen").style.display = "none";
        document.querySelectorAll("body *").forEach(function(elem) {
            elem.style.opacity = "1";
        });
        document.querySelector(".App").style.position = "absolute";
    }

    openBox = (that) => {
        var which = [
            this.state.title1,
            this.state.title2,
            this.state.title3,
            this.state.title4,
            this.state.title5,
            this.state.title6,
            this.state.title7,
            this.state.title8,
            this.state.title9,
            this.state.title10
        ];
        var index = which.indexOf(that.props.subject);
        var targ = document.getElementsByClassName("subject-line")[index].nextSibling;
        if (targ.style.display === "block") {
            targ.style.display = "none";
            targ.previousSibling.style.borderBottom = "1px solid rgb(150, 150, 150)";
            that.setState({downDisplay:{display:"inline-block"}});
            that.setState({upDisplay:{display:"none"}});
        } else {
            targ.style.display = "block";
            targ.previousSibling.style.borderBottom = "none";
            that.setState({downDisplay:{display:"none"}});
            that.setState({upDisplay:{display:"inline-block"}});
            var t = this;
            setTimeout(function() {
                var factor = document.querySelectorAll(".slider input")[index].clientWidth;
                t.setState({factor: factor});
            }, 250);
        }

        window.getSelection().removeAllRanges();
    }

    handleDropdown = (dat) => {
        console.log(dat);
        if (dat['UMSA User'] === "-1") {
            this.setState({
                noData: 100 - parseInt(dat['Married User']) - parseInt(dat['Married Non-User']),
                notSexuallyActive: 0,
                UMSAUser: parseInt(dat['UMSA User']),
                UMSANonUser: parseInt(dat['UMSA Non-User']),
                marriedUser: parseInt(dat['Married User']),
                marriedNonUser: parseInt(dat['Married Non-User'])
            });
        } else {
            this.setState({
                noData: 0,
                notSexuallyActive: 100 - parseInt(dat['UMSA User']) - parseInt(dat['UMSA Non-User']) - parseInt(dat['Married User']) - parseInt(dat['Married Non-User']),
                UMSAUser: parseInt(dat['UMSA User']),
                UMSANonUser: parseInt(dat['UMSA Non-User']),
                marriedUser: parseInt(dat['Married User']),
                marriedNonUser: parseInt(dat['Married Non-User'])
            });
        }
        this.setState({
            sliderValue1:Math.max(0, parseFloat(dat['Starting Point Policy'])),
            sliderValue2:Math.max(0, /*Math.round*/(parseFloat(dat['Starting Point PPFP']) * 100)),
            sliderValue3:Math.max(0, parseFloat(dat['Expand Access LARC Baseline'])),
            sliderValue4:Math.max(0, /*Math.round*/(parseFloat(dat['Starting Point CHW']) * 100)),
            sliderValue5:Math.max(0, parseFloat(dat['Starting Point Outreach']) * 100),
            sliderValue6:Math.max(0, /*Math.round*/(parseFloat(dat['Starting Point Pharma']) * 100)),
            sliderValue7:Math.max(0, parseFloat(dat['Starting Point Stockout'])),
            sliderValue8:Math.max(0, parseFloat(dat['Starting Point Youth'])),
            sliderValue9:Math.max(0, parseFloat(dat['Starting Point SBC'])),
            sliderValue10:Math.max(0, parseFloat(dat['Starting Point Media'])),
            sliderBaseline1: Math.max(0, parseFloat(dat['Starting Point Policy'])),
            sliderBaseline2: Math.max(0, /*Math.round*/(parseFloat(dat['Starting Point PPFP']) * 100)),
            sliderBaseline3: Math.max(0, parseFloat(dat['Expand Access LARC Baseline'])),
            sliderBaseline4: Math.max(0, /*Math.round*/(parseFloat(dat['Starting Point CHW']) * 100)),
            sliderBaseline5: Math.max(0, parseFloat(dat['Starting Point Outreach'])),
            sliderBaseline6: Math.max(0, /*Math.round*/(parseFloat(dat['Starting Point Pharma']) * 100)),
            sliderBaseline7: Math.max(0, parseFloat(dat['Starting Point Stockout'])),
            sliderBaseline8: Math.max(0, parseFloat(dat['Starting Point Youth'])),
            sliderBaseline9: Math.max(0, parseFloat(dat['Starting Point SBC'])),
            sliderBaseline10: Math.max(0, parseFloat(dat['Starting Point Media'])),
            visPolicy: parseInt(dat['Starting Point Policy']) < 0 ? "block" : "none",
            visPPFP: parseInt(dat['Starting Point PPFP']) < 0 ? "block" : "none",
            visLARC: parseInt(dat['Expand Access LARC Baseline']) < 0 ? "block" : "none",
            visCHW: parseInt(dat['Starting Point CHW']) < 0 ? "block" : "none",
            visOutreach: parseInt(dat['Starting Point Outreach']) < 0 ? "block" : "none",
            visPharma: parseInt(dat['Starting Point Pharma']) < 0 ? "block" : "none",
            visStockout: parseInt(dat['Starting Point Stockout']) < 0 ? "block" : "none",
            visYouth: parseInt(dat['Starting Point Youth']) < 0 ? "block" : "none",
            visSBC: parseInt(dat['Starting Point SBC']) < 0 ? "block" : "none",
            visMedia: parseInt(dat['Starting Point Media']) < 0 ? "block" : "none",
            tableStart1: this.commafy(Math.max(0, parseInt(dat['Num Births Baseline']) * parseFloat(dat['Starting Point PPFP']))),
            tableStart2: this.commafy(Math.max(0, parseFloat((dat['Starting Point CHW'])) * (parseInt(dat['WRA Baseline']) / 250))),
            tableStart3: this.commafy(Math.max(0, parseFloat((dat['Starting Point Outreach'])) * (parseInt(dat['WRA Baseline']) / 2500))),
            tableStart4: this.commafy(Math.max(0, parseFloat((dat['Starting Point Pharma'])) * (parseInt(dat['WRA Baseline']) / 1500))),
            tableStart5: this.commafy(Math.max(0, Math.min(parseInt(dat['Stockout Pills Baseline']), parseInt(dat['Stockout Injectables Baseline']), parseInt(dat['Stockout Implant Baseline']), parseInt(dat['Stockout IUD Baseline']), parseInt(dat['Stockout Condom Baseline'])))),
            tableStart6: this.commafy(Math.max(0, Math.max(parseInt(dat['Stockout Pills Baseline']), parseInt(dat['Stockout Injectables Baseline']), parseInt(dat['Stockout Implant Baseline']), parseInt(dat['Stockout IUD Baseline']), parseInt(dat['Stockout Condom Baseline'])))),
            tableStart7: this.commafy(Math.max(0, parseFloat(dat['Starting Point Youth']) * (parseInt(dat['WRA 15-19 Baseline']) + parseInt(dat['WRA 20-24 Baseline'])))),
            tableStart8: this.commafy(Math.max(0, parseFloat(dat['Starting Point SBC']) / 100 * parseInt(dat['WRA Baseline']))),
            tableStart9: this.commafy(Math.max(0, parseFloat(dat['Starting Point Media']) / 100 * parseInt(dat['WRA Baseline']))),
            upArrow1:"hidden",
            upArrow2:"hidden",
            upArrow3:"hidden",
            upArrow4:"hidden",
            upArrow5:"hidden",
            upArrow6:"hidden",
            upArrow7:"hidden",
            upArrow8:"hidden",
            upArrow9:"hidden",
            upArrow10:"hidden",
            downArrow1:"hidden",
            downArrow2:"hidden",
            downArrow3:"hidden",
            downArrow4:"hidden",
            downArrow5:"hidden",
            downArrow6:"hidden",
            downArrow7:"hidden",
            downArrow8:"hidden",
            downArrow9:"hidden",
            downArrow10:"hidden",
            yw: {
                title: "Distribution of youth by marital status, sexual activity, and contraceptive use",
                yAxisLabel: "% of Youth (15 - 24)",
                chartType: 12,
                showLegend:true,
                subsetLabels: [
                    "Unmarried, No Data On Sexual Activity",
                    "Unmarried Not Sexually Active",
                    "Unmarried Sexually Active",
                    "Married Youth"
                ],
                subsetColors: [
                    "lightgrey",
                    "darkgrey",
                    "lightblue",
                    "darkblue"
                ],
                subsetsToLegend: "",
                chartData: [[
                    [0],
                    [0],
                    [this.state.noData]
                ],
                    [
                        [0],
                        [0],
                        [this.state.notSexuallyActive]
                    ],
                    [
                        [this.state.UMSAUser],
                        [this.state.UMSANonUser],
                        [0]
                    ],
                    [
                        [this.state.marriedUser],
                        [this.state.marriedNonUser],
                        [0]
                    ]],
                stacking:true,
                pointLabels: [
                    "Users",
                    "Non Users *",
                    "Not Sexually Active"
                ],
            },
            stock:{
                title: "Stock outs by method",
                subsetLabels: [
                    "Stockout",
                    "Stockout",
                    "Stockout",
                    "Stockout",
                    "Stockout"
                ],
                subsetColors: [
                    "blue",
                    "blue",
                    "blue",
                    "blue",
                    "blue"
                ],
                subsetsToLegend: "",
                chartData: [[
                    [parseInt(dat['Stockout Condom Baseline'])],
                    [parseInt(dat['Stockout Pills Baseline'])],
                    [parseInt(dat['Stockout Injectables Baseline'])],
                    [parseInt(dat['Stockout IUD Baseline'])],
                    [parseInt(dat['Stockout Implant Baseline'])]
                ]],
                pointLabels: [
                    "Condom (m)",
                    "Pills",
                    "Injectables",
                    "IUD",
                    "Implant"
                ],
            }
        });

        var ob = {
            'country': document.querySelector("select").value,
            'Policy': this.state.sliderValue1,//document.getElementsByTagName("input")[0].value,
            'PPFP': this.state.sliderValue2,//document.getElementsByTagName("input")[6].value,
            'LARC': this.state.sliderValue3,//document.getElementsByTagName("input")[2].value,
            'CHW': this.state.sliderValue4,//document.getElementsByTagName("input")[3].value/* === "0" ? parseFloat(dat['Starting Point CHW']) * 100 : document.getElementsByTagName("input")[3].value*/,
            'MobileOutreach': this.state.sliderValue5,//document.getElementsByTagName("input")[4].value,
            'Pharma': this.state.sliderValue6,//document.getElementsByTagName("input")[5].value,
            'Stockout': this.state.sliderValue7,//document.getElementsByTagName("input")[1].value,
            'Comprehensive': this.state.sliderValue8,//document.getElementsByTagName("input")[7].value,
            'SBC': this.state.sliderValue9,//document.getElementsByTagName("input")[8].value,
            'MassMedia': this.state.sliderValue10,//document.getElementsByTagName("input")[9].value
        }
        GoalsService.changeResults(parseInt(ob['country']), parseFloat(ob['Policy']), parseFloat(ob['PPFP']), parseFloat(ob['LARC']), parseFloat(ob['CHW']), parseFloat(ob['MobileOutreach']), parseFloat(ob['Pharma']), parseFloat(ob['Stockout']), parseFloat(ob['Comprehensive']), parseFloat(ob['SBC']), parseFloat(ob['MassMedia']), (result) => this.handleSliders(JSON.parse(result.Result), ob, 0));

    }

    percentify = (n) => {
        return /*Math.round*/(parseFloat(n) * 100);
    }

    estim = (num) => {
        if (num < 1000) {
            num = Math.round(num / 10) * 10;
        } else if (num < 100000) {
            num = Math.round(num / 100) * 100;
        } else if (num > 100000) {
            num = Math.round(num / 1000) * 1000;
        }
        return num;
    }

    commafy = (n) => {
        var num = this.estim(parseInt(n)).toString();
        if (num.length < 4) {
            return num;
        } else if (num.length % 3 === 0) {
            var x = num.match(/.{1,3}/g);
            return x.join(",");
        } else if (num.length %3 === 1) {
            var str = num.substring(0, 1);
            var x = num.replace(str, "").match(/.{1,3}/g);
            x.unshift(str);
            return x.join(",");
        } else if (num.length % 3 === 2) {
            var str = num.substring(0, 2);
            var x = num.replace(str, "").match(/.{1,3}/g);
            x.unshift(str);
            return x.join(",");
        }
    }

    averageGrowth = (num) => {
        return num + (((-0.0008*((num*100) * (num))) + (0.0537*(num*100)) + 0.1717)/100);
    }

    matchVal = (num, n) => {
        return document.querySelector(".App > article:first-of-type > div:nth-of-type(" + num + ") > div:nth-of-type(2) > div:nth-of-type(" + n + ") > section:nth-of-type(2) > p:first-of-type").innerText;
    }

    weigh = (n) => {
        return n;//Math.round(n) < 1 ? 0 : n;
    }

    handleSliders = (dat, o, targ) => {
        console.log(dat);
        document.querySelector("#message-target").innerHTML = dat['Policy Bar Message'];
        if (dat['Policy Bar Message'] === "Without changes to your policy environment, mCPR growth will be slowed.") {
            document.querySelector("#message-target").style.color = "red";
            this.setState({badgeColor:"red"});
            document.querySelector(".badge").innerHTML = "&#8856;";
        } else {
            document.querySelector("#message-target").style.color = "green";
            this.setState({badgeColor: "green"});
            document.querySelector(".badge").innerHTML = "&#10004;";
        }

        if (Math.round(this.percentify(dat['mCPR PPFP'])) > Math.round(this.state.scaleValue1)) {
            this.setState({
                upArrow2:"visible",
                downArrow2:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR PPFP'])) < Math.round(this.state.scaleValue1)) {
            this.setState({
                upArrow2:"hidden",
                downArrow2:"visible"
            });
        } else {
            this.setState({
                upArrow2:"hidden",
                downArrow2:"hidden"
            });
        }
        if (Math.round(this.percentify(Math.max(dat['mCPR Stockout Low'], dat['mCPR Stockout High']))) > Math.round(this.state.scaleValue2)) {
            this.setState({
                upArrow3:"visible",
                downArrow3:"hidden"
            });
        } else if (Math.round(this.percentify(Math.max(dat['mCPR Stockout Low'], dat['mCPR Stockout High']))) < Math.round(this.state.scaleValue2)) {
            this.setState({
                upArrow3:"hidden",
                downArrow3:"visible"
            });
        } else {
            this.setState({
                upArrow3:"hidden",
                downArrow3:"hidden"
            });
        }
        if (Math.round(this.percentify(dat['mCPR CHW'])) > Math.round(this.state.scaleValue3)) {
            this.setState({
                upArrow4:"visible",
                downArrow4:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR CHW'])) < Math.round(this.state.scaleValue3)) {
            this.setState({
                upArrow4:"hidden",
                downArrow4:"visible"
            });
        } else {
            this.setState({
                upArrow4:"hidden",
                downArrow4:"hidden"
            });
        }
        if (Math.round(this.percentify(dat['mCPR Mobile Outreach'])) > Math.round(this.state.scaleValue4)) {
            this.setState({
                upArrow5:"visible",
                downArrow5:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR Mobile Outreach'])) < Math.round(this.state.scaleValue4)) {
            this.setState({
                upArrow5:"hidden",
                downArrow5:"visible"
            });
        } else {
            this.setState({
                upArrow5:"hidden",
                downArrow5:"hidden"
            });
        }
        if (Math.round(this.percentify(dat['mCPR Pharma'])) > Math.round(this.state.scaleValue5)) {
            this.setState({
                upArrow6:"visible",
                downArrow6:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR Pharma'])) < Math.round(this.state.scaleValue5)) {
            this.setState({
                upArrow6:"hidden",
                downArrow6:"visible"
            });
        } else {
            this.setState({
                upArrow6:"hidden",
                downArrow6:"hidden"
            });
        }
        if (Math.round(this.percentify(dat['mCPR Stockout Reduction'])) > Math.round(this.state.scaleValue6)) {
            this.setState({
                upArrow7:"visible",
                downArrow7:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR Stockout Reduction'])) < Math.round(this.state.scaleValue6)) {
            this.setState({
                upArrow7:"hidden",
                downArrow7:"visible"
            });
        } else {
            this.setState({
                upArrow7:"hidden",
                downArrow7:"hidden"
            });
        }
        if (Math.round(this.percentify(dat['mCPR Youth Intervention'])) > Math.round(this.state.scaleValue7)) {
            this.setState({
                upArrow8:"visible",
                downArrow8:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR Youth Intervention'])) < Math.round(this.state.scaleValue7)) {
            this.setState({
                upArrow8:"hidden",
                downArrow8:"visible"
            });
        } else {
            this.setState({
                upArrow8:"hidden",
                downArrow8:"hidden"
            });
        }
        if (Math.round(this.percentify(dat['mCPR SBC'])) > Math.round(this.state.scaleValue8)) {
            this.setState({
                upArrow9:"visible",
                downArrow9:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR SBC'])) < Math.round(this.state.scaleValue8)) {
            this.setState({
                upArrow9:"hidden",
                downArrow9:"visible"
            });
        } else {
            this.setState({
                upArrow9:"hidden",
                downArrow9:"hidden"
            });
        }
        if (Math.round(this.percentify(dat['mCPR Mass Media'])) > Math.round(this.state.scaleValue9)) {
            this.setState({
                upArrow10:"visible",
                downArrow10:"hidden"
            });
        } else if (Math.round(this.percentify(dat['mCPR Mass Media'])) < Math.round(this.state.scaleValue9)) {
            this.setState({
                upArrow10:"hidden",
                downArrow10:"visible"
            });
        } else {
            this.setState({
                upArrow10:"hidden",
                downArrow10:"hidden"
            });
        }
        this.setState({
            tableValue1: /*this.state.sliderBaseline2 === this.state.sliderValue2 ? this.matchVal(8, 2) : */this.commafy(dat['Postpartum Endline']),
            tableValue2: /*this.state.sliderBaseline4 === this.state.sliderValue4 ? this.matchVal(5, 2) : */this.commafy(dat['CHW Endline']),
            tableValue3: /*this.state.sliderBaseline5 === this.state.sliderValue5 ? this.matchVal(6, 2) : */this.commafy(dat['Mobile Outreach Endline']),
            tableValue4: /*this.state.sliderBaseline6 === this.state.sliderValue6 ? this.matchVal(7, 2) : */this.commafy(dat['Pharmacies and Drug Shops Endline']),
            tableValue5: this.commafy(dat['Stockout Reductions Endline']),
            tableValue6: this.commafy(dat['Stockout Endline']),
            tableValue7: /*this.state.sliderBaseline8 === this.state.sliderValue8 ? this.matchVal(9, 3) : */this.commafy(dat['Youth Interventions Endline']),
            tableValue8: /*this.state.sliderBaseline9 === this.state.sliderValue9 ? this.matchVal(10, 2) : */this.commafy(dat['SBC Endline'] * 2),
            tableValue9: /*this.state.sliderBaseline10 === this.state.sliderValue10 ? this.matchVal(11, 2) : */this.commafy(dat['Mass Media Endline']),
            barValue: this.percentify(dat['Policy Bar Value']),
            graphValue: parseInt(dat['Line Graph Sixth Point']),
            // scaleValue1: Math.max(0, this.percentify(dat['mCPR PPFP'])),
            // scaleValue2: Math.max(0, this.percentify(Math.max(dat['mCPR Stockout Low'], dat['mCPR Stockout High']))),
            // scaleValue3: Math.max(0, this.percentify(dat['mCPR CHW'])),
            // scaleValue4: Math.max(0, this.percentify(dat['mCPR Mobile Outreach'])),
            // scaleValue5: Math.max(0, this.percentify(dat['mCPR Pharma'])),
            // scaleValue6: Math.max(0, this.percentify(dat['mCPR Stockout Reduction'])),
            // scaleValue7: Math.max(0, this.percentify(dat['mCPR Youth Intervention'])),
            // scaleValue8: Math.max(0, this.percentify(dat['mCPR SBC'])),
            // scaleValue9: Math.max(0, this.percentify(dat['mCPR Mass Media'])),
            scaleValue1: this.percentify(dat['mCPR PPFP']),
            scaleValue2: this.percentify(Math.max(dat['mCPR Stockout Low'], dat['mCPR Stockout High'])),
            scaleValue3: this.percentify(dat['mCPR CHW']),
            scaleValue4: this.percentify(dat['mCPR Mobile Outreach']),
            scaleValue5: this.percentify(dat['mCPR Pharma']),
            scaleValue6: this.percentify(dat['mCPR Stockout Reduction']),
            scaleValue7: this.percentify(dat['mCPR Youth Intervention']),
            scaleValue8: this.percentify(dat['mCPR SBC']),
            scaleValue9: this.percentify(dat['mCPR Mass Media']),
            sliderValue1: o['Policy'],
            sliderValue2: o['PPFP'],
            sliderValue3: o['LARC'],
            sliderValue4: o['CHW'],
            sliderValue5: o['MobileOutreach'],
            sliderValue6: o['Pharma'],
            sliderValue7: o['Stockout'],
            sliderValue8: o['Comprehensive'],
            sliderValue9: o['SBC'],
            sliderValue10: o['MassMedia'],
            bar:{
                title: "",
                yAxisLabel:"% pt increase in mCPR (2017 to 2022)",
                subsetLabels: [
                    "Percentage",
                    // this.state.title1,
                    this.state.title2,
                    this.state.title3,
                    this.state.title4,
                    this.state.title5,
                    this.state.title6,
                    this.state.title7,
                    this.state.title8,
                    this.state.title9,
                    this.state.title10
                ],
                subsetColors: [
                    "rgb(150, 150, 150, 0.25)",
                    this.state.colorStockout,
                    this.state.colorLARC,
                    this.state.colorCHW,
                    this.state.colorOutreach,
                    this.state.colorPharma,
                    this.state.colorPPFP,
                    this.state.colorYouth,
                    this.state.colorSBC,
                    this.state.colorMedia
                ],
                pointLabels: [
                    "Increase in mCPR",
                    "Growth limited by low demand"
                ],
                subsetsToLegend: "",
                stacking: true,
                chartData: [
                    [
                        [0],
                        [this.percentify(dat['Policy Bar Value'])]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR Stockout Reduction']))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(Math.max(dat['mCPR Stockout Low'], dat['mCPR Stockout High'])))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR CHW']))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR Mobile Outreach']))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR Pharma']))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR PPFP']))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR Youth Intervention']))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR SBC']))]
                    ],
                    [
                        [/*parseInt*/this.weigh(this.percentify(dat['mCPR Mass Media']))]
                    ]
                ]
            },
            obj:{
                yAxisLabel: "mCPR (all women)",
                title: "",
                subsetLabels: [
                    "Average",
                    "Highest",
                    "Projected"
                ],
                subsetColors: [
                    "grey",
                    "orange",
                    "green"
                ],
                subsetsToLegend: "",
                chartData: [
                    [
                        [2017, this.percentify(dat['mCPR Baseline'])],
                        [2022, this.averageGrowth(this.averageGrowth(this.averageGrowth(this.averageGrowth(this.averageGrowth(this.averageGrowth(this.percentify(dat['mCPR Baseline'])))))))]
                    ],
                    [
                        [2017, this.percentify(dat['mCPR Baseline'])],
                        [2022, this.percentify(dat['mCPR Baseline']) + 20]
                    ],
                    [
                        [2017, this.percentify(dat['mCPR Baseline'])],
                        [2022, parseFloat(dat['Line Graph Sixth Point'])]
                    ]
                ]
            }
        });
        if (targ === 0) {
            this.setState({
                upArrow1:"hidden",
                downArrow1:"hidden",
                upArrow2:"hidden",
                downArrow2:"hidden",
                upArrow3:"hidden",
                downArrow3:"hidden",
                upArrow4:"hidden",
                downArrow4:"hidden",
                upArrow5:"hidden",
                downArrow5:"hidden",
                upArrow6:"hidden",
                downArrow6:"hidden",
                upArrow7:"hidden",
                downArrow7:"hidden",
                upArrow8:"hidden",
                downArrow8:"hidden",
                upArrow9:"hidden",
                downArrow9:"hidden",
                upArrow10:"hidden",
                downArrow10:"hidden",
            });
        }
    }

    render() {

        return (
            <div className="App">
                <header>
                    <span>
                        <img style={{padding:"5px", float:"left"}} src="FamPlan 48 n p.png" alt="FamPlan logo" />
                        <h1>FP Goals Lite</h1>
                    </span>
                    <span><p onClick={this.handleAbout}>About</p></span>
                </header>
                <div id="screen"></div>
                <dialog id="about">
                    <span onClick={this.handleX}>X</span>
                    <aside>Version 1.0</aside>
                    <h1>About</h1>
                    <hr />
                    <p><b>FP Goals</b> is an innovative new model designed to improve strategic planning. FP Goals combines demographic data, family planning program information, and evidence of the effectiveness of diverse interventions to help decision-makers set realistic goals and prioritize investments across different family planning interventions.</p>
                    <p>Learn more about FP Goals in this <a href="http://track20.org/download/pdf/FP%20Goals%20Overview%20for%20Website%20(2016.5.19).pdf" target="_blank">overview presentation</a></p>
                    <hr />
                    <a href="http://www.track20.org" target="_blank">
                        <img src="track20Logo.png" alt="Track20 Logo" />
                    </a>
                    <p>The Track20 Project, implemented by Avenir Health, monitors progress towards achieving the goals of the global FP2020 initiative, adding an additional 120 million modern method users between 2012 and 2020 in the world’s 69 poorest countries. Track20 works directly with governments in participating FP2020 countries to collect, analyze and use data to monitor progress annually in family planning and to actively use data to improve family planning strategies and plans.</p>
                    <hr />
                    <a href="http://www.avenirhealth.org" target="_blank">
                        <img src="avenirLogo.png" alt="AvenirHealth Logo" />
                    </a>
                    <p>FP Goals Lite is developed by Avenir Health.</p>
                    <span onClick={this.handleX}>OK</span>
                </dialog>
                <br />
                <p style={{padding:"0 50px"}}>The FP Goals Lite tool uses available family planning data to illustrate how initiating or scaling up different interventions might affect a country’s modern contraceptive prevalence rate among all women of reproductive age.  To use this tool first select a country in step 1 below, then define intervention scale up under step 2 for included interventions.  Results under step 3 will update as you change intervention scale up.</p>
                <p style={{padding:"0 50px"}}>This tool is meant to provide a quick glance at results based on select interventions.  It does not replace the more robust results you would get from a full application of FP Goals.  Learn more about the full FP Goals model <a target="_blank" href="http://track20.org/pages/track20_tools/FPgoals.php">here</a>.</p>
                <article>
                    <Dropdown func={(inf) => this.handleDropdown(JSON.parse(inf.Result))} />
                    <h5 className="directions">2. Define intervention scale-up</h5>
                    <p>Open each intervention box below to change the endline coverage and see how this changes the projected mCPR growth (right side).</p>
                    <p>Baseline year is 2017.  Endline year is 2022.</p>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow1} downArrow={this.state.downArrow1} check={this.state.checkDisplay1} subject={this.state.title1} color={this.state.badgeColor} valu="&#8856;" />
                        <div className="toolbox">
                            <Slider vis={this.state.visPolicy} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 1)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline1)} endline={Math.round(this.state.sliderValue1)} heading="FPE Policy Score" />
                            <p id="message-target">Without changes to your policy environment, mCPR growth will be slowed.</p>
                            <Message msg="What specific policy changes would be made to improve the policy environment?  How feasible are positive policy changes related to FP?" />
                            <Closer />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow7} downArrow={this.state.downArrow7} check={this.state.checkDisplay7} subject={this.state.title2} color={this.state.colorStockout} valu={Math.round(this.state.scaleValue6) + "%"} />
                        <div className="toolbox">
                            <p className="attn">Measure: % of Facilities Stocked Out on the Day of Assessment, by method<br /><i style={{fontSize:"12px"}}>Note: no baseline data available</i></p>
                            <GBStdChart id="comparison" packChart={this.state.stock} stretch={false} minHeight={200} maxHeight={200} chartType="bar" />
                            <Slider vis={this.state.visStockout} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 7)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline7)} endline={Math.round(this.state.sliderValue7)} heading="% of existing stock outs to be eliminated" />
                            <Message msg="What barriers are driving stock outs?  What could be done to address those barriers?  How much of existing stock outs could realistically be addressed? " />
                            {/*<Table start={this.state.tableStart5} end={this.state.tableValue5} expo={"Stockouts by method would reduce by " + this.state.sliderValue7 + "%"} />*/}
                            {/*<Table start={this.state.tableStart6} end={this.state.tableValue6} expo="Implying that the lowest and highest levels of stock outs for any given method would change as follows:" />*/}
                            {/*<aside>*/}
                            {/*<p>Lowest</p>*/}
                            {/*<p>Highest</p>*/}
                            {/*</aside>*/}
                            <Scale num={this.state.scaleValue6} color={this.state.colorStockout} />
                            <Closer />
                            <Tooltip tip="Option to update data sources for stockouts (e.g. LMIS or other facility survey)" />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow3} downArrow={this.state.downArrow3} check={this.state.checkDisplay3} subject={this.state.title3} color={this.state.colorLARC} valu={Math.round(this.state.scaleValue2) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visLARC} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 3)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline3)} endline={Math.round(this.state.sliderValue3)} heading="Extent to which entire population has access to LARCs -!*!*!- Baseline Source: FPE 2014" />
                            <Message msg="How would expanded access to LARCs be achieved?  How much of an increase is feasible given staffing, training, and supervision needs to support expanded provision?" />
                            <div id="breakout">
                                <p>
                                    <span>{this.state.breakoutBase1}</span>
                                    <span>{this.state.breakoutEnd1}</span>
                                </p>
                                <p>
                                    <span>{this.state.breakoutBase2}</span>
                                    <span>{this.state.breakoutEnd2}</span>
                                </p>
                            </div>
                            <Scale num={this.state.scaleValue2} color={this.state.colorLARC} />
                            <Closer />
                            <Tooltip tip="Ability to increase provision of specific methods by country-specific facility type/level (e.g. implants at health posts) and tailored baseline coverage data based on program data." />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow4} downArrow={this.state.downArrow4} check={this.state.checkDisplay4} subject={this.state.title4} color={this.state.colorCHW} valu={Math.round(this.state.scaleValue3) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visCHW} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 4)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline4)} endline={Math.round(this.state.sliderValue4)} heading="% of women covered by CHWs/CBDs offering FP methods -!*!*!- Baseline Source: DHS (proxy: % women getting their FP method from CHW/CBD)" />
                            <Table start={this.state.tableStart2} end={this.state.tableValue2} expo="# of CHWs needed to achieve planned coverage" />
                            <Message msg="How many CHWs can feasibly be trained, supported, and supervised?  What FP methods can CHWs provide? Are CHWs currently used as a source of FP by women in the country?" />
                            <br />
                            <Scale num={this.state.scaleValue3} color={this.state.colorCHW} />
                            <Closer />
                            <Tooltip tip="Option to add task-sharing (e.g. allow CHWs to provide injections), ability to adjust the productivity/reach of CHWs, and tailored baseline coverage data, based on existing policies and programs." />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow5} downArrow={this.state.downArrow5} check={this.state.checkDisplay5} subject={this.state.title5} color={this.state.colorOutreach} valu={Math.round(this.state.scaleValue4) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visOutreach} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 5)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline5)} endline={Math.round(this.state.sliderValue5)} heading="% of women covered by mobile outreach services -!*!*!- Baseline Source: DHS (proxy: % women getting their FP method from mobile outreach)" />
                            <Table start={this.state.tableStart3} end={this.state.tableValue3} expo="# of mobile outreach teams needed to achieve planned coverage" />
                            <Message msg="How many mobile outreach teams could feasibly be supported?   What methods can be provided through mobile outreach? Where would mobile outreach teams be deployed? Hard to reach areas? Rural areas?  Urban informal settlements" />
                            <br />
                            <Scale num={this.state.scaleValue4} color={this.state.colorOutreach} />
                            <Closer />
                            <Tooltip tip="Ability to adjust the productivity/reach of mobile outreach teams and tailored baseline coverage data, based on existing policies and programs." />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow6} downArrow={this.state.downArrow6} check={this.state.checkDisplay6} subject={this.state.title6} color={this.state.colorPharma} valu={Math.round(this.state.scaleValue5) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visPharma} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 6)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline6)} endline={Math.round(this.state.sliderValue6)} heading="% of women covered by pharmacies/drug shops offering FP methods -!*!*!- Baseline Source: DHS (proxy: % women getting their FP method from pharmacies/drug shops)" />
                            <Table start={this.state.tableStart4} end={this.state.tableValue4} expo="# of pharmacies/ shops offering FP services needed to achieve planned coverage" />
                            <Message msg="What FP methods can pharmacies/drug shops provide?  What training and support would be needed? Are pharmacies/drug shops currently used a common source of FP by women in the country?" />

                            <Scale num={this.state.scaleValue5} color={this.state.colorPharma} />
                            <Closer />
                            <Tooltip tip="Option to add task-sharing (e.g. allow pharmacies to provide injections), ability to adjust the productivity/reach of pharmacy/drug shops, and tailored baseline coverage data, based on existing policies and programs." />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow2} downArrow={this.state.downArrow2} check={this.state.checkDisplay2} subject={this.state.title7} color={this.state.colorPPFP} valu={Math.round(this.state.scaleValue1) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visPPFP} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 2)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline2)} endline={Math.round(this.state.sliderValue2)} heading="% of women using FP at 6 months postpartum -!*!*!- Baseline Source: DHS/MICS" />
                            <br />
                            <Table start={this.state.tableStart1} end={this.state.tableValue1} expo="# women reached by intervention" />
                            <Message msg="How would these women be reached?  Are there enough resources availiable for this scale-up, given the number of women that would need to be reached? Are there challenges to integrating FP into MNCH programming?  " />
                            <br />
                            <p>
                                <i>Note: The highest national levels of PPFP uptake seen at 6 months are around 70%; consider this in relation to planned scale-up.</i>
                            </p>
                            <Scale num={this.state.scaleValue1} color={this.state.colorPPFP} />
                            <Closer />
                            <Tooltip tip="Option to specify the type(s) of PPFP intervention to be introduced or scaled-up: community-based, facility based (immediate v integrated into PNC), immunization integration and tailored baseline coverage data, based on demographic and program data." />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow8} downArrow={this.state.downArrow8} check={this.state.checkDisplay8} subject={this.state.title8} color={this.state.colorYouth} valu={Math.round(this.state.scaleValue7) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visYouth} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 8)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline8)} endline={Math.round(this.state.sliderValue8)} heading="% of young women (15-24) reached by comprehensive interventions -!*!*!- Note: assume baseline of 0 due to limited data on existing youth programs" />
                            <GBStdChart id="youth_breakdown" packChart={this.state.yw} stretch={false} minHeight={350} maxHeight={350} chartType="column" />
                            <img style={{display:"none", margin: "auto"}} src='/youth-legend.png' />
                            <i>*Youth who are not using a modern method of contraception are assumed to be those who can be impacted by youth interventions.</i>
                            <Table start={this.state.tableStart7} end={this.state.tableValue7} expo="# of young women reached by intervention" />
                            <Message msg="What mechanisms would be used to reach these young women?  How would strategies differ by education (in vs out of school), marital status (married vs unmarried) and other key segments? What barriers exist limiting youth access to FP and would these interventions address those?" />

                            <br />
                            {/*<i>Note: assume baseline of 0 due to limited data on existing youth programs</i>*/}
                            <Scale num={this.state.scaleValue7} color={this.state.colorYouth} />
                            <Closer />
                            <Tooltip tip="Option to specify the type of youth interventions to be introduced or scaled up (e.g. comphrehensive engagement, curriculum based) and tailored baseline data, based on country demographic and program data. " />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow9} downArrow={this.state.downArrow9} check={this.state.checkDisplay9} subject={this.state.title9} color={this.state.colorSBC} valu={Math.round(this.state.scaleValue8) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visSBC} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 9)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline9)} endline={Math.round(this.state.sliderValue9)} heading="% of women reached via comprehensive community engagement -!*!*!- Baseline Source: FPE (Coverage of home visit workers)" />
                            <Table start={this.state.tableStart8} end={this.state.tableValue8} expo="# women reached by intervention" />
                            <Message msg="What mechanisms would be used to reach these women? Are these mechanisms scaleable to the level needed to achieve the intended coverage?" />

                            <Scale num={this.state.scaleValue8} color={this.state.colorSBC} />
                            <Closer />
                            <Tooltip tip="Option to specify the type of SBC interventions scaled-up (community engagement, inter-personal communication) and tailored baseline coverage data, based on existing programs." />
                        </div>
                    </div>
                    <div className="tool">
                        <hr />
                        <SubjectLine func={(line) => this.openBox(line)} upArrow={this.state.upArrow10} downArrow={this.state.downArrow10} check={this.state.checkDisplay10} subject={this.state.title10} color={this.state.colorMedia} valu={Math.round(this.state.scaleValue9) + "%"} />
                        <div className="toolbox">
                            <Slider vis={this.state.visMedia} func={(inf, obj) => this.handleSliders(JSON.parse(inf.Result), obj, 10)} factor={this.state.factor} baseline={Math.round(this.state.sliderBaseline10)} endline={Math.round(this.state.sliderValue10)} heading="% of women reached by FP messages via mass media -!*!*!- Baseline Source: DHS (proxy: % of women receiving FP messages via mass media recently)" />
                            <Table start={this.state.tableStart9} end={this.state.tableValue9} expo="# of women reached by mass media SBC intervention" />
                            <Message msg="How would mass media campaigns be developed and disseminated?  What types of mass media (tv, radio, etc) might be most effective at reaching women?" />

                            <Scale num={this.state.scaleValue9} color={this.state.colorMedia} />
                            <Closer />
                            <Tooltip tip="Tailored baseline coverage data, based on existing programs." />
                        </div>
                    </div>
                </article>

                <article>
                    <h5 className="directions">3. Review results: impact of selected scale-up</h5>
                    <article className="graph">
                        <TitleBanner banner="Projected mCPR growth (all women)" />
                        <article>
                            <GBStdChart id="projection" packChart={this.state.obj} stretch={false} minHeight={250} maxHeight={250} chartType="line" />
                            <Label color="green" cat="Projected" />
                            <Label color="orange" cat="Highest recorded*" />
                            <Label color="grey" cat="Average" />
                            <p><i>*highest is based on Rwanda (4% pts/year AW), average is average of countries at similar level of mCPR</i></p>
                        </article>
                        <div className="helpful">
                            <p>Two benchmarks have been provided to help contextualize the projected growth.</p>
                            <p>Growth that is close to or faster than the most rapid growth ever recorded may not be feasible.  Look back at scale-up plans to see if they are realistic to achieve.</p>
                            <p>Growth that is below the average may indicate there is room for scale-up to be more ambitious.</p>
                        </div>
                    </article>
                    <article className="graph">
                        <TitleBanner banner="Contribution of each intervention to overall growth" />
                        <article>
                            <GBStdChart id="increase" packChart={this.state.bar} stretch={false} minHeight={325} maxHeight={325} chartType="column" />
                        </article>
                        <article>
                            <Legend color={this.state.colorStockout} cat={this.state.title2} />
                            <Legend color={this.state.colorLARC} cat={this.state.title3} />
                            <Legend color={this.state.colorCHW} cat={this.state.title4} />
                            <Legend color={this.state.colorOutreach} cat={this.state.title5} />
                            <Legend color={this.state.colorPharma} cat={this.state.title6} />
                            <Legend color={this.state.colorPPFP} cat={this.state.title7} />
                            <Legend color={this.state.colorYouth} cat={this.state.title8} />
                            <Legend color={this.state.colorSBC} cat={this.state.title9} />
                            <Legend color={this.state.colorMedia} cat={this.state.title10} />
                        </article>
                        <div className="helpful">
                            <p>The first bar on the graph above shows the estimated % point contribution of each intervention area to the overall increase in mCPR.</p>
                            <p>The second bar shows if the model is estimating that there is not enough latent demand to allow all of the increase in mCPR projected based on intervention scale-up to be realized.  If growth is limited by low demand, intervention scale-up should be reconsidered to ensure the right balance between access and demand side interventions</p>
                        </div>
                    </article>
                    <a style={{float:"right"}} target="_blank" href="http://track20.org/pages/track20_tools/FPgoals.php">Learn more about FP Goals</a>
                </article>
            </div>
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/app/App.js